@if (isLoading) {
  <div class="spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
}

<h1>{{ pageTitle }}</h1>

@if (!isLoading) {
  <mat-card class="results-card">
    @if (isNResultsDataValid()) {
      <div class="results-content">
        <div class="result-columns">
          <div class="result-column w-50">
            <app-simulation-overview
              [simulationResponse]="simulationResponse"
              [directions]="['x', 'y', 'z']"
            ></app-simulation-overview>
            <mat-expansion-panel [expanded]="false" style="margin-top: 10px;">
              <mat-expansion-panel-header>
                <mat-panel-title>Simulation Processing Times</mat-panel-title>
              </mat-expansion-panel-header>
              <app-simulation-directions-table
                [simulationResponse]="simulationResponse"
                [directions]="['x', 'y', 'z']"
              ></app-simulation-directions-table>
            </mat-expansion-panel>
          </div>
          <div class="result-column w-50">
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>Simulation Parameters</mat-panel-title>
              </mat-expansion-panel-header>
              <div>
                @if (!isUpscaling) {
                  <p class="simulation-details">
                    <span>Interfacial Tension (N/m):</span> {{ simulationResponse?.parameters?.interfactialTension ?? '—' }}
                  </p>
                }
                @if (!isUpscaling) {
                  <div class="contact-angle-tree">
                    <div class="tree-parent">
                      <span class="tree-label">Contact Angle cosine</span>
                    </div>
                    <div class="tree-children">
                      <div class="tree-child">
                        <span class="tree-connector"></span>
                        <span class="tree-item-label">Primary Drainage (PD):</span>
                        <span class="tree-item-value">{{ simulationResponse?.parameters?.contactAnglePrimaryDrainage ?? '—' }}</span>
                      </div>
                      <div class="tree-child">
                        <span class="tree-connector"></span>
                        <span class="tree-item-label">First Imbibition (FI):</span>
                        <span class="tree-item-value">{{ simulationResponse?.parameters?.contactAngleFirstImbibition ?? '—' }}</span>
                      </div>
                    </div>
                  </div>
                }
                <form [formGroup]="cyclesForm">
                  <div class="input-row">
                    <span>Cycles</span>
                    <div class="direction-options">
                      <mat-checkbox formControlName="pd">PD</mat-checkbox>
                      <mat-checkbox formControlName="fi">FI</mat-checkbox>
                      <mat-checkbox formControlName="sd">SD</mat-checkbox>
                    </div>
                  </div>
                </form>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="false" style="margin-top: 10px;">
              <mat-expansion-panel-header>
                <mat-panel-title>Related simulations</mat-panel-title>
              </mat-expansion-panel-header>
              <div>
                <p class="simulation-details">
                  <span>Capillary Pressure:</span>
                  @if (capillaryPressure && parentSimulationId) {
                    <a
                      (click)="openParentSimulation()"
                      class="simulation-link"
                      >
                      {{ capillaryPressure }}
                    </a>
                  } @else {
                    {{ capillaryPressure ?? '—' }}
                  }
                </p>
              </div>
            </mat-expansion-panel>
          </div>
        </div>
        @if (isSimulationResultValid()) {
          <div class="result-columns">
            <div class="result-column w-50">
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title>Saturation Exponent curve</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="chart-container">
                  <highcharts-chart
                    style="width: 100%; height: 550px; display: block; border: 1px solid var(--main_borderColor)"
                    [Highcharts]="Highcharts"
                    [options]="chartOptions"
                    (chartInstance)="saveChartInstance($event)"
                  ></highcharts-chart>
                </div>
              </mat-expansion-panel>
            </div>
            <div class="result-column w-50">
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title>Chart data</mat-panel-title>
                  <button
                    mat-raised-button
                    color="primary"
                    type="button"
                    [disabled]="!isNResultsDataValid() || !isSimulationResultValid() || !displayedColumns.length"
                    (click)="downloadResults(); $event.stopPropagation()"
                    class="header-button"
                    >
                    <mat-icon>download</mat-icon>
                    Download
                  </button>
                </mat-expansion-panel-header>
                @if (displayedColumns.length) {
                  <!-- Saturation Exponent (n) Table -->
                  @if (nTableData.length) {
                    <div class="n-values-table">
                      <h3>Saturation Exponent (n) Values</h3>
                      <div class="scroll-x">
                        <table mat-table [dataSource]="nTableData">
                          @for (column of nTableColumns; track column) {
                            <ng-container [matColumnDef]="column">
                              <th mat-header-cell
                                *matHeaderCellDef
                                [ngStyle]="getColumnStyle(column)"
                              >{{ column }}</th>
                              <td mat-cell *matCellDef="let row">{{ row[column] ?? '—' }}</td>
                            </ng-container>
                          }
                          <tr mat-header-row *matHeaderRowDef="nTableColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: nTableColumns"></tr>
                        </table>
                      </div>
                    </div>
                  }
                  <!-- Chart Data Table -->
                  <div class="scroll-x">
                    <table mat-table [dataSource]="tableData">
                      @for (column of displayedColumns; track column) {
                        <ng-container [matColumnDef]="column">
                          <th mat-header-cell
                            *matHeaderCellDef
                            [ngStyle]="getColumnStyle(column)"
                          >{{ column }}</th>
                          <td mat-cell *matCellDef="let row">{{ row[column] ?? '—' }}</td>
                        </ng-container>
                      }
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                  </div>
                } @else {
                  <div class="no-table-data">
                    <p>No data. Please select the cycle to display simulation results.</p>
                  </div>
                }
              </mat-expansion-panel>
            </div>
          </div>
        } @else {
          <div class="no-results">
            <mat-icon class="no-results-icon">info</mat-icon>
            <p>Unable to create saturation exponent curve.</p>
          </div>
        }
      </div>
    } @else {
      <div class="no-results padding">
        <mat-icon class="no-results-icon">info</mat-icon>
        <p>No result available for this simulation yet.</p>
      </div>
    }
  </mat-card>
}




<ng-template #statusUnavailable>
  <mat-chip class="direction-status status-not-started">—</mat-chip>
</ng-template>
